import { PlaceholderLink } from '@mosey/components/navigation/PlaceholderLink';

export const AddIntegrationLink = () => {
  return (
    <PlaceholderLink to="/onboarding/setup">Add integration</PlaceholderLink>
  );
};
